import type { SensorSummary } from '@/apis/telemetry';

/** One sensor as the charts and legend show it. */
export interface Device {
  id: string;
  label: string;
  color: string;
}

/** Line colours by priority rank, as theme variables defined in global.scss; a fifth device reuses the first. */
export const DEVICE_COLORS: readonly string[] = [
  'var(--sensor-device-1)',
  'var(--sensor-device-2)',
  'var(--sensor-device-3)',
  'var(--sensor-device-4)',
];

/** The summary's sensors, which the API returns in priority order, each with its label and colour. */
export const devicesOf = (sensors: readonly SensorSummary[]): Device[] =>
  sensors.map((sensor, index) => ({
    id: sensor.id,
    label: sensor.label ?? sensor.tracking_id,
    color: DEVICE_COLORS[index % DEVICE_COLORS.length],
  }));
